
/** --------------------------------------------------------------------------------------------------
 * 開啟'確認刪除'視窗
 *
 *
 * @param message 要顯示的訊息
 * @param btn_yes 要顯示在 yes/ok 按鈕的文字; 給 null 將不會顯示此按鈕
 * @param btn_no  要顯示在 no/cancel 按鈕的文字; 給 null 將不會顯示此按鈕
 * @param title   標題文字
 * @param observer function 當使用者點選'是'或'否'後,會呼叫的 function;
 *                 使用者點選'btn_yes'會回傳 true;
 *                 使用者點選'btn_no'會回傳 false;
 *
 * -------------------------------------------------------------------------------------------------- */

window.confirmDialog = function(message, btn_yes, btn_no, title, observer) {

    title   = (title   !== undefined && title   !== null && title   !== '') ? title   : '系統通知';
    btn_yes = (btn_yes !== undefined && btn_yes !== null && btn_yes !== '') ? btn_yes : '確認';
    btn_no  = (btn_no  !== undefined && btn_no  !== null && btn_no  !== '') ? btn_no  : null;

    if ($('#rd-confirm-dialog').length === 0) {
        $('body').append('<div class="pop-box" id="rd-confirm-dialog">'+
                         '  <div class="black-bg"></div>'+
                         '  <div class="pop-content-show">'+
                         '      <div class="viewbox">'+
                         '          <button type="button" class="close-btn" id="rd-confirm-close-icon"></button>'+
                         '          <div class="box-tit marb_30" id="rd-confirm-dialog-title"></div>'+
                         '          <div class="box-txt marb_20" id="rd-confirm-dialog-message"></div>'+
                         '          <div class="btn-tool">'+
                         '              <div class="col-4 btn" id="rd-confirm-submit-button"><button type="button" class="yel-btn col-12"></button></div>'+
                         '              <div class="col-4 btn" id="rd-confirm-close-button"><button type="button" class="yel-btn col-12"></button></div>'+
                         '          </div>'+
                         '      </div>'+
                         '  </div>'+
                         '</div>');
    }

    let confirm_dialog = $('#rd-confirm-dialog');

    confirm_dialog.find('#rd-confirm-dialog-title').html(title);
    confirm_dialog.find('#rd-confirm-dialog-message').html(message);

    if(btn_yes !== null && btn_yes !== ''){

        confirm_dialog.find('#rd-confirm-submit-button').show().children('button').html(btn_yes);

        $('#rd-confirm-submit-button').unbind('click').on('click', function() {
            confirm_dialog.hide();
            if (observer !== undefined && observer !== null) {
                observer(true);
            }
        });
    }else{
        confirm_dialog.find('#rd-confirm-submit-button').hide();
    }

    if(btn_no !== null && btn_no !== '') {

        confirm_dialog.find('#rd-confirm-close-button').show().children('button').html(btn_no);

        $('#rd-confirm-close-button').unbind('click').on('click', function() {
            confirm_dialog.hide();
            if (observer !== undefined && observer !== null) {
                observer(false);
            }
        });
    }else{
        confirm_dialog.find('#rd-confirm-close-button').hide();
    }

    $('#rd-confirm-close-icon').unbind('click').on('click', function() {
        confirm_dialog.hide();
        if (observer !== undefined && observer !== null) {
            if(btn_no !== null && btn_no !== '') {
                observer(false);
            }else{
                observer(true);
            }
        }
    });

    confirm_dialog.show();
}
